import { c as _c } from "react/compiler-runtime";
import { AdminIcon, BrowserIcon, FileAttachment01Icon, GitPullRequestIcon, HomeLineIcon, Mail04Icon, MessageDotsSquareIcon, Sale01Icon, User03Icon } from '@systemeio/icons';
import { pageRoute } from 'shared/constants/routes.constants';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePermission } from 'shared/hooks/use-permission';
import { useRouter } from 'shared/hooks/use-router';
import useUser from 'shared/hooks/use-user';
import { formUrl } from 'shared/utils/links/form-url';
import type { MenuItem } from '../types/menu-item';
export const useMenuItems = () => {
  const $ = _c(401);
  const {
    t
  } = useLocoTranslation();
  const {
    isWsAssistant,
    isStudent
  } = useUser();
  const {
    pathname
  } = useRouter();
  const {
    pagePermissions,
    isReady
  } = usePermission();
  let t0;
  if ($[0] !== pathname) {
    t0 = url => pathname.includes(url);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const regularIsActiveCheck = t0;
  let t1;
  if ($[2] !== pagePermissions) {
    t1 = route => Boolean(pagePermissions[pageRoute[route]]);
    $[2] = pagePermissions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasPermission = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("header.top_menu.dashboard");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("header.top_menu.main_dashboard");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = hasPermission("Dashboard");
  let t5;
  if ($[8] !== pathname) {
    t5 = url_0 => pathname === url_0;
    $[8] = pathname;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = {
      name: t3,
      href: pageRoute.Dashboard,
      shouldRender: t4,
      isActive: t5,
      dataTestId: "dashboard-main-link"
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("header.top_menu.affiliate_dashboard");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = hasPermission("AffiliateDashboard");
  let t9;
  if ($[16] !== regularIsActiveCheck || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      name: t7,
      href: pageRoute.AffiliateDashboard,
      shouldRender: t8,
      isActive: regularIsActiveCheck,
      dataTestId: "dashboard-affiliate-link"
    };
    $[16] = regularIsActiveCheck;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("header.top_menu.student_dashboard");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isStudent) {
    t11 = isStudent ? formUrl("/school", false) ?? "" : formUrl("/school?tab=explore_courses", false) ?? "";
    $[22] = isStudent;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== isStudent || $[25] !== regularIsActiveCheck || $[26] !== t10 || $[27] !== t11) {
    t12 = {
      name: t10,
      shouldRender: isStudent,
      href: t11,
      isActive: regularIsActiveCheck,
      dataTestId: "dashboard-student-link"
    };
    $[24] = isStudent;
    $[25] = regularIsActiveCheck;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("header.top_menu.agency_dashboard");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = hasPermission("AgencyUsers");
  let t15;
  if ($[31] !== pathname) {
    t15 = () => pathname.includes("/agency-center");
    $[31] = pathname;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t13 || $[34] !== t14 || $[35] !== t15) {
    t16 = {
      name: t13,
      href: pageRoute.AgencyUsers,
      shouldRender: t14,
      isActive: t15,
      dataTestId: "dashboard-agency-link"
    };
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t16 || $[39] !== t6 || $[40] !== t9) {
    t17 = [t6, t9, t12, t16];
    $[37] = t12;
    $[38] = t16;
    $[39] = t6;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t17 || $[43] !== t2) {
    t18 = {
      id: "dashboard",
      name: t2,
      dropdownItems: t17,
      mobileIconRenderer: _temp
    };
    $[42] = t17;
    $[43] = t2;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t) {
    t19 = t("header.top_menu.crm");
    $[45] = t;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t) {
    t20 = t("header.top_menu.contacts");
    $[47] = t;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  const t21 = isWsAssistant ? pageRoute.AssistantContacts : pageRoute.Contacts;
  const t22 = isWsAssistant ? hasPermission("AssistantContacts") : hasPermission("Contacts");
  let t23;
  if ($[49] !== regularIsActiveCheck || $[50] !== t20 || $[51] !== t21 || $[52] !== t22) {
    t23 = {
      name: t20,
      href: t21,
      isActive: regularIsActiveCheck,
      shouldRender: t22,
      dataTestId: "crm-contacts-link"
    };
    $[49] = regularIsActiveCheck;
    $[50] = t20;
    $[51] = t21;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t) {
    t24 = t("header.top_menu.tags");
    $[54] = t;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  const t25 = hasPermission("Tags");
  let t26;
  if ($[56] !== regularIsActiveCheck || $[57] !== t24 || $[58] !== t25) {
    t26 = {
      name: t24,
      href: pageRoute.Tags,
      isActive: regularIsActiveCheck,
      shouldRender: t25,
      dataTestId: "crm-tags-link"
    };
    $[56] = regularIsActiveCheck;
    $[57] = t24;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t) {
    t27 = t("header.top_menu.crm_pipeline");
    $[60] = t;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  const t28 = hasPermission("CrmPipeline");
  let t29;
  if ($[62] !== regularIsActiveCheck || $[63] !== t27 || $[64] !== t28) {
    t29 = {
      name: t27,
      href: pageRoute.CrmPipeline,
      isActive: regularIsActiveCheck,
      shouldRender: t28,
      dataTestId: "crm-pipeline-link"
    };
    $[62] = regularIsActiveCheck;
    $[63] = t27;
    $[64] = t28;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t) {
    t30 = t("header.top_menu.calendar");
    $[66] = t;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  const t31 = hasPermission("Calendar");
  let t32;
  if ($[68] !== regularIsActiveCheck || $[69] !== t30 || $[70] !== t31) {
    t32 = {
      name: t30,
      href: pageRoute.Calendar,
      isActive: regularIsActiveCheck,
      shouldRender: t31,
      dataTestId: "crm-calendar-link"
    };
    $[68] = regularIsActiveCheck;
    $[69] = t30;
    $[70] = t31;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== t23 || $[73] !== t26 || $[74] !== t29 || $[75] !== t32) {
    t33 = [t23, t26, t29, t32];
    $[72] = t23;
    $[73] = t26;
    $[74] = t29;
    $[75] = t32;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] !== t19 || $[78] !== t33) {
    t34 = {
      id: "crm",
      name: t19,
      dropdownItems: t33,
      mobileIconRenderer: _temp2
    };
    $[77] = t19;
    $[78] = t33;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== t) {
    t35 = t("header.top_menu.sites");
    $[80] = t;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== t) {
    t36 = t("header.top_menu.website");
    $[82] = t;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  const t37 = hasPermission("Websites");
  let t38;
  if ($[84] !== regularIsActiveCheck || $[85] !== t36 || $[86] !== t37) {
    t38 = {
      name: t36,
      href: pageRoute.Websites,
      shouldRender: t37,
      isActive: regularIsActiveCheck,
      dataTestId: "sites-website-link"
    };
    $[84] = regularIsActiveCheck;
    $[85] = t36;
    $[86] = t37;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== t) {
    t39 = t("header.top_menu.funnels");
    $[88] = t;
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  const t40 = hasPermission("Funnels");
  let t41;
  if ($[90] !== regularIsActiveCheck || $[91] !== t39 || $[92] !== t40) {
    t41 = {
      name: t39,
      href: pageRoute.Funnels,
      isActive: regularIsActiveCheck,
      shouldRender: t40,
      dataTestId: "sites-funnels-link"
    };
    $[90] = regularIsActiveCheck;
    $[91] = t39;
    $[92] = t40;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== t) {
    t42 = t("header.top_menu.digital_stores");
    $[94] = t;
    $[95] = t42;
  } else {
    t42 = $[95];
  }
  const t43 = hasPermission("Stores");
  let t44;
  if ($[96] !== regularIsActiveCheck || $[97] !== t42 || $[98] !== t43) {
    t44 = {
      name: t42,
      href: pageRoute.Stores,
      isActive: regularIsActiveCheck,
      shouldRender: t43,
      dataTestId: "sites-digital-stores-link"
    };
    $[96] = regularIsActiveCheck;
    $[97] = t42;
    $[98] = t43;
    $[99] = t44;
  } else {
    t44 = $[99];
  }
  let t45;
  if ($[100] !== t) {
    t45 = t("header.top_menu.blogs");
    $[100] = t;
    $[101] = t45;
  } else {
    t45 = $[101];
  }
  const t46 = hasPermission("Blogs");
  let t47;
  if ($[102] !== regularIsActiveCheck || $[103] !== t45 || $[104] !== t46) {
    t47 = {
      name: t45,
      href: pageRoute.Blogs,
      isActive: regularIsActiveCheck,
      shouldRender: t46,
      dataTestId: "sites-blogs-link"
    };
    $[102] = regularIsActiveCheck;
    $[103] = t45;
    $[104] = t46;
    $[105] = t47;
  } else {
    t47 = $[105];
  }
  let t48;
  if ($[106] !== t38 || $[107] !== t41 || $[108] !== t44 || $[109] !== t47) {
    t48 = [t38, t41, t44, t47];
    $[106] = t38;
    $[107] = t41;
    $[108] = t44;
    $[109] = t47;
    $[110] = t48;
  } else {
    t48 = $[110];
  }
  let t49;
  if ($[111] !== t35 || $[112] !== t48) {
    t49 = {
      id: "sites",
      name: t35,
      dropdownItems: t48,
      mobileIconRenderer: _temp3
    };
    $[111] = t35;
    $[112] = t48;
    $[113] = t49;
  } else {
    t49 = $[113];
  }
  let t50;
  if ($[114] !== t) {
    t50 = t("header.top_menu.emails");
    $[114] = t;
    $[115] = t50;
  } else {
    t50 = $[115];
  }
  let t51;
  if ($[116] !== t) {
    t51 = t("header.top_menu.newsletters");
    $[116] = t;
    $[117] = t51;
  } else {
    t51 = $[117];
  }
  const t52 = hasPermission("Newsletters");
  let t53;
  if ($[118] !== regularIsActiveCheck || $[119] !== t51 || $[120] !== t52) {
    t53 = {
      name: t51,
      href: pageRoute.Newsletters,
      isActive: regularIsActiveCheck,
      shouldRender: t52,
      dataTestId: "emails-newsletters-link"
    };
    $[118] = regularIsActiveCheck;
    $[119] = t51;
    $[120] = t52;
    $[121] = t53;
  } else {
    t53 = $[121];
  }
  let t54;
  if ($[122] !== t) {
    t54 = t("header.top_menu.campaigns");
    $[122] = t;
    $[123] = t54;
  } else {
    t54 = $[123];
  }
  const t55 = hasPermission("Campaigns");
  let t56;
  if ($[124] !== regularIsActiveCheck || $[125] !== t54 || $[126] !== t55) {
    t56 = {
      name: t54,
      href: pageRoute.Campaigns,
      isActive: regularIsActiveCheck,
      shouldRender: t55,
      dataTestId: "emails-campaigns-link"
    };
    $[124] = regularIsActiveCheck;
    $[125] = t54;
    $[126] = t55;
    $[127] = t56;
  } else {
    t56 = $[127];
  }
  let t57;
  if ($[128] !== t) {
    t57 = t("header.top_menu.email_statistics");
    $[128] = t;
    $[129] = t57;
  } else {
    t57 = $[129];
  }
  const t58 = hasPermission("EmailStatistics");
  let t59;
  if ($[130] !== regularIsActiveCheck || $[131] !== t57 || $[132] !== t58) {
    t59 = {
      name: t57,
      href: pageRoute.EmailStatistics,
      isActive: regularIsActiveCheck,
      shouldRender: t58,
      dataTestId: "emails-statistics-link"
    };
    $[130] = regularIsActiveCheck;
    $[131] = t57;
    $[132] = t58;
    $[133] = t59;
  } else {
    t59 = $[133];
  }
  let t60;
  if ($[134] !== t53 || $[135] !== t56 || $[136] !== t59) {
    t60 = [t53, t56, t59];
    $[134] = t53;
    $[135] = t56;
    $[136] = t59;
    $[137] = t60;
  } else {
    t60 = $[137];
  }
  let t61;
  if ($[138] !== t50 || $[139] !== t60) {
    t61 = {
      id: "emails",
      name: t50,
      dropdownItems: t60,
      mobileIconRenderer: _temp4
    };
    $[138] = t50;
    $[139] = t60;
    $[140] = t61;
  } else {
    t61 = $[140];
  }
  let t62;
  if ($[141] !== t) {
    t62 = t("header.top_menu.sms");
    $[141] = t;
    $[142] = t62;
  } else {
    t62 = $[142];
  }
  let t63;
  if ($[143] !== t) {
    t63 = t("header.top_menu.sms_templates");
    $[143] = t;
    $[144] = t63;
  } else {
    t63 = $[144];
  }
  const t64 = hasPermission("SmsTemplates");
  let t65;
  if ($[145] !== regularIsActiveCheck || $[146] !== t63 || $[147] !== t64) {
    t65 = {
      name: t63,
      href: pageRoute.SmsTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t64,
      dataTestId: "sms-templates-link"
    };
    $[145] = regularIsActiveCheck;
    $[146] = t63;
    $[147] = t64;
    $[148] = t65;
  } else {
    t65 = $[148];
  }
  let t66;
  if ($[149] !== t) {
    t66 = t("header.top_menu.sms_statistics");
    $[149] = t;
    $[150] = t66;
  } else {
    t66 = $[150];
  }
  const t67 = hasPermission("SmsStatistics");
  let t68;
  if ($[151] !== regularIsActiveCheck || $[152] !== t66 || $[153] !== t67) {
    t68 = {
      name: t66,
      href: pageRoute.SmsStatistics,
      isActive: regularIsActiveCheck,
      shouldRender: t67,
      dataTestId: "sms-statistics-link"
    };
    $[151] = regularIsActiveCheck;
    $[152] = t66;
    $[153] = t67;
    $[154] = t68;
  } else {
    t68 = $[154];
  }
  let t69;
  if ($[155] !== t65 || $[156] !== t68) {
    t69 = [t65, t68];
    $[155] = t65;
    $[156] = t68;
    $[157] = t69;
  } else {
    t69 = $[157];
  }
  let t70;
  if ($[158] !== t62 || $[159] !== t69) {
    t70 = {
      id: "sms",
      name: t62,
      dropdownItems: t69,
      mobileIconRenderer: _temp5
    };
    $[158] = t62;
    $[159] = t69;
    $[160] = t70;
  } else {
    t70 = $[160];
  }
  let t71;
  if ($[161] !== t) {
    t71 = t("header.top_menu.automations");
    $[161] = t;
    $[162] = t71;
  } else {
    t71 = $[162];
  }
  let t72;
  if ($[163] !== t) {
    t72 = t("header.top_menu.rules");
    $[163] = t;
    $[164] = t72;
  } else {
    t72 = $[164];
  }
  const t73 = hasPermission("AutomationRules");
  let t74;
  if ($[165] !== regularIsActiveCheck || $[166] !== t72 || $[167] !== t73) {
    t74 = {
      name: t72,
      href: pageRoute.AutomationRules,
      isActive: regularIsActiveCheck,
      shouldRender: t73,
      dataTestId: "automations-rules-link"
    };
    $[165] = regularIsActiveCheck;
    $[166] = t72;
    $[167] = t73;
    $[168] = t74;
  } else {
    t74 = $[168];
  }
  let t75;
  if ($[169] !== t) {
    t75 = t("header.top_menu.workflows");
    $[169] = t;
    $[170] = t75;
  } else {
    t75 = $[170];
  }
  const t76 = hasPermission("Workflows");
  let t77;
  if ($[171] !== regularIsActiveCheck || $[172] !== t75 || $[173] !== t76) {
    t77 = {
      name: t75,
      href: pageRoute.Workflows,
      isActive: regularIsActiveCheck,
      shouldRender: t76,
      dataTestId: "automations-workflows-link"
    };
    $[171] = regularIsActiveCheck;
    $[172] = t75;
    $[173] = t76;
    $[174] = t77;
  } else {
    t77 = $[174];
  }
  let t78;
  if ($[175] !== t74 || $[176] !== t77) {
    t78 = [t74, t77];
    $[175] = t74;
    $[176] = t77;
    $[177] = t78;
  } else {
    t78 = $[177];
  }
  let t79;
  if ($[178] !== t71 || $[179] !== t78) {
    t79 = {
      id: "automations",
      name: t71,
      dropdownItems: t78,
      mobileIconRenderer: _temp6
    };
    $[178] = t71;
    $[179] = t78;
    $[180] = t79;
  } else {
    t79 = $[180];
  }
  let t80;
  if ($[181] !== t) {
    t80 = t("header.top_menu.products");
    $[181] = t;
    $[182] = t80;
  } else {
    t80 = $[182];
  }
  let t81;
  if ($[183] !== t) {
    t81 = t("header.top_menu.physical_product");
    $[183] = t;
    $[184] = t81;
  } else {
    t81 = $[184];
  }
  const t82 = hasPermission("Products");
  let t83;
  if ($[185] !== regularIsActiveCheck || $[186] !== t81 || $[187] !== t82) {
    t83 = {
      name: t81,
      href: pageRoute.Products,
      isActive: regularIsActiveCheck,
      shouldRender: t82,
      dataTestId: "products-physical-product-link"
    };
    $[185] = regularIsActiveCheck;
    $[186] = t81;
    $[187] = t82;
    $[188] = t83;
  } else {
    t83 = $[188];
  }
  let t84;
  if ($[189] !== t) {
    t84 = t("header.top_menu.coupons");
    $[189] = t;
    $[190] = t84;
  } else {
    t84 = $[190];
  }
  const t85 = hasPermission("Coupons");
  let t86;
  if ($[191] !== regularIsActiveCheck || $[192] !== t84 || $[193] !== t85) {
    t86 = {
      name: t84,
      href: pageRoute.Coupons,
      isActive: regularIsActiveCheck,
      shouldRender: t85,
      dataTestId: "products-coupons-link"
    };
    $[191] = regularIsActiveCheck;
    $[192] = t84;
    $[193] = t85;
    $[194] = t86;
  } else {
    t86 = $[194];
  }
  let t87;
  if ($[195] !== t) {
    t87 = t("header.top_menu.courses");
    $[195] = t;
    $[196] = t87;
  } else {
    t87 = $[196];
  }
  const t88 = hasPermission("Courses");
  let t89;
  if ($[197] !== regularIsActiveCheck || $[198] !== t87 || $[199] !== t88) {
    t89 = {
      name: t87,
      href: pageRoute.Courses,
      isActive: regularIsActiveCheck,
      shouldRender: t88,
      dataTestId: "products-courses-link"
    };
    $[197] = regularIsActiveCheck;
    $[198] = t87;
    $[199] = t88;
    $[200] = t89;
  } else {
    t89 = $[200];
  }
  let t90;
  if ($[201] !== t) {
    t90 = t("header.top_menu.communities");
    $[201] = t;
    $[202] = t90;
  } else {
    t90 = $[202];
  }
  const t91 = hasPermission("Communities");
  let t92;
  if ($[203] !== regularIsActiveCheck || $[204] !== t90 || $[205] !== t91) {
    t92 = {
      name: t90,
      href: pageRoute.Communities,
      isActive: regularIsActiveCheck,
      shouldRender: t91,
      dataTestId: "products-communities-link"
    };
    $[203] = regularIsActiveCheck;
    $[204] = t90;
    $[205] = t91;
    $[206] = t92;
  } else {
    t92 = $[206];
  }
  let t93;
  if ($[207] !== t) {
    t93 = t("header.top_menu.files");
    $[207] = t;
    $[208] = t93;
  } else {
    t93 = $[208];
  }
  const t94 = hasPermission("Files");
  let t95;
  if ($[209] !== regularIsActiveCheck || $[210] !== t93 || $[211] !== t94) {
    t95 = {
      name: t93,
      href: pageRoute.Files,
      isActive: regularIsActiveCheck,
      shouldRender: t94,
      dataTestId: "products-files-link"
    };
    $[209] = regularIsActiveCheck;
    $[210] = t93;
    $[211] = t94;
    $[212] = t95;
  } else {
    t95 = $[212];
  }
  let t96;
  if ($[213] !== t83 || $[214] !== t86 || $[215] !== t89 || $[216] !== t92 || $[217] !== t95) {
    t96 = [t83, t86, t89, t92, t95];
    $[213] = t83;
    $[214] = t86;
    $[215] = t89;
    $[216] = t92;
    $[217] = t95;
    $[218] = t96;
  } else {
    t96 = $[218];
  }
  let t97;
  if ($[219] !== t80 || $[220] !== t96) {
    t97 = {
      id: "products",
      name: t80,
      dropdownItems: t96,
      mobileIconRenderer: _temp7
    };
    $[219] = t80;
    $[220] = t96;
    $[221] = t97;
  } else {
    t97 = $[221];
  }
  let t98;
  if ($[222] !== t) {
    t98 = t("header.top_menu.sales");
    $[222] = t;
    $[223] = t98;
  } else {
    t98 = $[223];
  }
  let t99;
  if ($[224] !== t) {
    t99 = t("header.top_menu.orders");
    $[224] = t;
    $[225] = t99;
  } else {
    t99 = $[225];
  }
  const t100 = hasPermission("Orders");
  let t101;
  if ($[226] !== regularIsActiveCheck || $[227] !== t100 || $[228] !== t99) {
    t101 = {
      name: t99,
      href: pageRoute.Orders,
      isActive: regularIsActiveCheck,
      shouldRender: t100,
      dataTestId: "sales-orders-link"
    };
    $[226] = regularIsActiveCheck;
    $[227] = t100;
    $[228] = t99;
    $[229] = t101;
  } else {
    t101 = $[229];
  }
  let t102;
  if ($[230] !== t) {
    t102 = t("header.top_menu.transactions");
    $[230] = t;
    $[231] = t102;
  } else {
    t102 = $[231];
  }
  const t103 = hasPermission("Transactions");
  let t104;
  if ($[232] !== regularIsActiveCheck || $[233] !== t102 || $[234] !== t103) {
    t104 = {
      name: t102,
      href: pageRoute.Transactions,
      isActive: regularIsActiveCheck,
      shouldRender: t103,
      dataTestId: "sales-transactions-link"
    };
    $[232] = regularIsActiveCheck;
    $[233] = t102;
    $[234] = t103;
    $[235] = t104;
  } else {
    t104 = $[235];
  }
  let t105;
  if ($[236] !== t) {
    t105 = t("header.top_menu.subscriptions");
    $[236] = t;
    $[237] = t105;
  } else {
    t105 = $[237];
  }
  const t106 = hasPermission("Subscriptions");
  let t107;
  if ($[238] !== regularIsActiveCheck || $[239] !== t105 || $[240] !== t106) {
    t107 = {
      name: t105,
      href: pageRoute.Subscriptions,
      isActive: regularIsActiveCheck,
      shouldRender: t106,
      dataTestId: "sales-subscriptions-link"
    };
    $[238] = regularIsActiveCheck;
    $[239] = t105;
    $[240] = t106;
    $[241] = t107;
  } else {
    t107 = $[241];
  }
  let t108;
  if ($[242] !== t) {
    t108 = t("header.top_menu.affiliate_invoices");
    $[242] = t;
    $[243] = t108;
  } else {
    t108 = $[243];
  }
  const t109 = hasPermission("AffiliateInvoices");
  let t110;
  if ($[244] !== regularIsActiveCheck || $[245] !== t108 || $[246] !== t109) {
    t110 = {
      name: t108,
      href: pageRoute.AffiliateInvoices,
      shouldRender: t109,
      isActive: regularIsActiveCheck,
      dataTestId: "sales-affiliate-invoices-link"
    };
    $[244] = regularIsActiveCheck;
    $[245] = t108;
    $[246] = t109;
    $[247] = t110;
  } else {
    t110 = $[247];
  }
  let t111;
  if ($[248] !== t) {
    t111 = t("header.top_menu.affiliate_program");
    $[248] = t;
    $[249] = t111;
  } else {
    t111 = $[249];
  }
  const t112 = hasPermission("AffiliateProgram");
  let t113;
  if ($[250] !== regularIsActiveCheck || $[251] !== t111 || $[252] !== t112) {
    t113 = {
      name: t111,
      href: pageRoute.AffiliateProgram,
      shouldRender: t112,
      isActive: regularIsActiveCheck,
      dataTestId: "sales-affiliate-program-link"
    };
    $[250] = regularIsActiveCheck;
    $[251] = t111;
    $[252] = t112;
    $[253] = t113;
  } else {
    t113 = $[253];
  }
  let t114;
  if ($[254] !== t101 || $[255] !== t104 || $[256] !== t107 || $[257] !== t110 || $[258] !== t113) {
    t114 = [t101, t104, t107, t110, t113];
    $[254] = t101;
    $[255] = t104;
    $[256] = t107;
    $[257] = t110;
    $[258] = t113;
    $[259] = t114;
  } else {
    t114 = $[259];
  }
  let t115;
  if ($[260] !== t114 || $[261] !== t98) {
    t115 = {
      id: "sales",
      name: t98,
      dropdownItems: t114,
      mobileIconRenderer: _temp8
    };
    $[260] = t114;
    $[261] = t98;
    $[262] = t115;
  } else {
    t115 = $[262];
  }
  let t116;
  if ($[263] !== t) {
    t116 = t("header.top_menu.admin.admin");
    $[263] = t;
    $[264] = t116;
  } else {
    t116 = $[264];
  }
  let t117;
  if ($[265] !== t) {
    t117 = t("header.top_menu.admin.users");
    $[265] = t;
    $[266] = t117;
  } else {
    t117 = $[266];
  }
  const t118 = hasPermission("AdminUsers");
  let t119;
  if ($[267] !== regularIsActiveCheck || $[268] !== t117 || $[269] !== t118) {
    t119 = {
      name: t117,
      href: pageRoute.AdminUsers,
      shouldRender: t118,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-users-link"
    };
    $[267] = regularIsActiveCheck;
    $[268] = t117;
    $[269] = t118;
    $[270] = t119;
  } else {
    t119 = $[270];
  }
  let t120;
  if ($[271] !== t) {
    t120 = t("header.top_menu.admin.templates");
    $[271] = t;
    $[272] = t120;
  } else {
    t120 = $[272];
  }
  let t121;
  if ($[273] !== t) {
    t121 = t("header.top_menu.admin.email_templates");
    $[273] = t;
    $[274] = t121;
  } else {
    t121 = $[274];
  }
  const t122 = hasPermission("AdminEmailTemplates");
  let t123;
  if ($[275] !== regularIsActiveCheck || $[276] !== t121 || $[277] !== t122) {
    t123 = {
      name: t121,
      href: pageRoute.AdminEmailTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t122,
      dataTestId: "admin-templates-email-templates-link"
    };
    $[275] = regularIsActiveCheck;
    $[276] = t121;
    $[277] = t122;
    $[278] = t123;
  } else {
    t123 = $[278];
  }
  let t124;
  if ($[279] !== t) {
    t124 = t("header.top_menu.admin.page_templates");
    $[279] = t;
    $[280] = t124;
  } else {
    t124 = $[280];
  }
  const t125 = hasPermission("AdminPageTemplates");
  let t126;
  if ($[281] !== regularIsActiveCheck || $[282] !== t124 || $[283] !== t125) {
    t126 = {
      name: t124,
      href: pageRoute.AdminPageTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t125,
      dataTestId: "admin-templates-page-templates-link"
    };
    $[281] = regularIsActiveCheck;
    $[282] = t124;
    $[283] = t125;
    $[284] = t126;
  } else {
    t126 = $[284];
  }
  let t127;
  if ($[285] !== t) {
    t127 = t("header.top_menu.admin.blog_templates");
    $[285] = t;
    $[286] = t127;
  } else {
    t127 = $[286];
  }
  const t128 = hasPermission("AdminBlogTemplates");
  let t129;
  if ($[287] !== regularIsActiveCheck || $[288] !== t127 || $[289] !== t128) {
    t129 = {
      name: t127,
      href: pageRoute.AdminBlogTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t128,
      dataTestId: "admin-templates-blog-templates-link"
    };
    $[287] = regularIsActiveCheck;
    $[288] = t127;
    $[289] = t128;
    $[290] = t129;
  } else {
    t129 = $[290];
  }
  let t130;
  if ($[291] !== t) {
    t130 = t("header.top_menu.admin.website_templates");
    $[291] = t;
    $[292] = t130;
  } else {
    t130 = $[292];
  }
  const t131 = hasPermission("AdminWebsiteTemplates");
  let t132;
  if ($[293] !== regularIsActiveCheck || $[294] !== t130 || $[295] !== t131) {
    t132 = {
      name: t130,
      href: pageRoute.AdminWebsiteTemplates,
      shouldRender: t131,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-templates-website-templates-link"
    };
    $[293] = regularIsActiveCheck;
    $[294] = t130;
    $[295] = t131;
    $[296] = t132;
  } else {
    t132 = $[296];
  }
  let t133;
  if ($[297] !== t) {
    t133 = t("header.top_menu.admin.funnel_templates");
    $[297] = t;
    $[298] = t133;
  } else {
    t133 = $[298];
  }
  const t134 = hasPermission("AdminFunnelTemplates");
  let t135;
  if ($[299] !== regularIsActiveCheck || $[300] !== t133 || $[301] !== t134) {
    t135 = {
      name: t133,
      href: pageRoute.AdminFunnelTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t134,
      dataTestId: "admin-templates-funnel-templates-link"
    };
    $[299] = regularIsActiveCheck;
    $[300] = t133;
    $[301] = t134;
    $[302] = t135;
  } else {
    t135 = $[302];
  }
  let t136;
  if ($[303] !== t123 || $[304] !== t126 || $[305] !== t129 || $[306] !== t132 || $[307] !== t135) {
    t136 = [t123, t126, t129, t132, t135];
    $[303] = t123;
    $[304] = t126;
    $[305] = t129;
    $[306] = t132;
    $[307] = t135;
    $[308] = t136;
  } else {
    t136 = $[308];
  }
  let t137;
  if ($[309] !== t120 || $[310] !== t136) {
    t137 = {
      id: "admin-templates",
      name: t120,
      dropdownItems: t136
    };
    $[309] = t120;
    $[310] = t136;
    $[311] = t137;
  } else {
    t137 = $[311];
  }
  let t138;
  if ($[312] !== t) {
    t138 = t("header.top_menu.admin.customers");
    $[312] = t;
    $[313] = t138;
  } else {
    t138 = $[313];
  }
  const t139 = hasPermission("AdminCustomers");
  let t140;
  if ($[314] !== regularIsActiveCheck || $[315] !== t138 || $[316] !== t139) {
    t140 = {
      name: t138,
      href: pageRoute.AdminCustomers,
      shouldRender: t139,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-customers-link"
    };
    $[314] = regularIsActiveCheck;
    $[315] = t138;
    $[316] = t139;
    $[317] = t140;
  } else {
    t140 = $[317];
  }
  let t141;
  if ($[318] !== t) {
    t141 = t("header.top_menu.admin.emails");
    $[318] = t;
    $[319] = t141;
  } else {
    t141 = $[319];
  }
  const t142 = hasPermission("AdminEmailStats");
  let t143;
  if ($[320] !== regularIsActiveCheck || $[321] !== t141 || $[322] !== t142) {
    t143 = {
      name: t141,
      href: pageRoute.AdminEmailStats,
      shouldRender: t142,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-emails-link"
    };
    $[320] = regularIsActiveCheck;
    $[321] = t141;
    $[322] = t142;
    $[323] = t143;
  } else {
    t143 = $[323];
  }
  let t144;
  if ($[324] !== t) {
    t144 = t("header.top_menu.admin.user_plans");
    $[324] = t;
    $[325] = t144;
  } else {
    t144 = $[325];
  }
  const t145 = hasPermission("AdminUserPlans");
  let t146;
  if ($[326] !== regularIsActiveCheck || $[327] !== t144 || $[328] !== t145) {
    t146 = {
      name: t144,
      href: pageRoute.AdminUserPlans,
      shouldRender: t145,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-user-plans-link"
    };
    $[326] = regularIsActiveCheck;
    $[327] = t144;
    $[328] = t145;
    $[329] = t146;
  } else {
    t146 = $[329];
  }
  let t147;
  if ($[330] !== t) {
    t147 = t("header.top_menu.admin.domains_blocked");
    $[330] = t;
    $[331] = t147;
  } else {
    t147 = $[331];
  }
  const t148 = hasPermission("AdminDomainsBlocked");
  let t149;
  if ($[332] !== regularIsActiveCheck || $[333] !== t147 || $[334] !== t148) {
    t149 = {
      name: t147,
      href: pageRoute.AdminDomainsBlocked,
      shouldRender: t148,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-domains-blocked-link"
    };
    $[332] = regularIsActiveCheck;
    $[333] = t147;
    $[334] = t148;
    $[335] = t149;
  } else {
    t149 = $[335];
  }
  let t150;
  if ($[336] !== t) {
    t150 = t("header.top_menu.admin.domains_white_listed");
    $[336] = t;
    $[337] = t150;
  } else {
    t150 = $[337];
  }
  const t151 = hasPermission("AdminDomainsWhitelist");
  let t152;
  if ($[338] !== regularIsActiveCheck || $[339] !== t150 || $[340] !== t151) {
    t152 = {
      name: t150,
      href: pageRoute.AdminDomainsWhitelist,
      shouldRender: t151,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-domains-whitelisted-link"
    };
    $[338] = regularIsActiveCheck;
    $[339] = t150;
    $[340] = t151;
    $[341] = t152;
  } else {
    t152 = $[341];
  }
  let t153;
  if ($[342] !== t) {
    t153 = t("header.top_menu.admin.suspicious_content");
    $[342] = t;
    $[343] = t153;
  } else {
    t153 = $[343];
  }
  let t154;
  if ($[344] !== t) {
    t154 = t("header.top_menu.admin.suspicious_page_content_keywords");
    $[344] = t;
    $[345] = t154;
  } else {
    t154 = $[345];
  }
  const t155 = hasPermission("AdminSuspiciousPageKeywords");
  let t156;
  if ($[346] !== regularIsActiveCheck || $[347] !== t154 || $[348] !== t155) {
    t156 = {
      name: t154,
      href: pageRoute.AdminSuspiciousPageKeywords,
      isActive: regularIsActiveCheck,
      shouldRender: t155,
      dataTestId: "admin-suspicious-content-page-keywords-link"
    };
    $[346] = regularIsActiveCheck;
    $[347] = t154;
    $[348] = t155;
    $[349] = t156;
  } else {
    t156 = $[349];
  }
  let t157;
  if ($[350] !== t) {
    t157 = t("header.top_menu.admin.suspicious_email_keywords");
    $[350] = t;
    $[351] = t157;
  } else {
    t157 = $[351];
  }
  const t158 = hasPermission("AdminSuspiciousEmailKeywords");
  let t159;
  if ($[352] !== regularIsActiveCheck || $[353] !== t157 || $[354] !== t158) {
    t159 = {
      name: t157,
      href: pageRoute.AdminSuspiciousEmailKeywords,
      isActive: regularIsActiveCheck,
      shouldRender: t158,
      dataTestId: "admin-suspicious-content-email-keywords-link"
    };
    $[352] = regularIsActiveCheck;
    $[353] = t157;
    $[354] = t158;
    $[355] = t159;
  } else {
    t159 = $[355];
  }
  let t160;
  if ($[356] !== t) {
    t160 = t("header.top_menu.admin.suspicious_email_address");
    $[356] = t;
    $[357] = t160;
  } else {
    t160 = $[357];
  }
  const t161 = hasPermission("AdminSuspiciousEmailAddress");
  let t162;
  if ($[358] !== regularIsActiveCheck || $[359] !== t160 || $[360] !== t161) {
    t162 = {
      name: t160,
      href: pageRoute.AdminSuspiciousEmailAddress,
      isActive: regularIsActiveCheck,
      shouldRender: t161,
      dataTestId: "admin-suspicious-content-email-address-link"
    };
    $[358] = regularIsActiveCheck;
    $[359] = t160;
    $[360] = t161;
    $[361] = t162;
  } else {
    t162 = $[361];
  }
  let t163;
  if ($[362] !== t156 || $[363] !== t159 || $[364] !== t162) {
    t163 = [t156, t159, t162];
    $[362] = t156;
    $[363] = t159;
    $[364] = t162;
    $[365] = t163;
  } else {
    t163 = $[365];
  }
  let t164;
  if ($[366] !== t153 || $[367] !== t163) {
    t164 = {
      id: "admin-suspicious-content",
      name: t153,
      dropdownItems: t163
    };
    $[366] = t153;
    $[367] = t163;
    $[368] = t164;
  } else {
    t164 = $[368];
  }
  let t165;
  if ($[369] !== t) {
    t165 = t("header.top_menu.admin.statistics");
    $[369] = t;
    $[370] = t165;
  } else {
    t165 = $[370];
  }
  const t166 = hasPermission("AdminStatistics");
  let t167;
  if ($[371] !== regularIsActiveCheck || $[372] !== t165 || $[373] !== t166) {
    t167 = {
      name: t165,
      href: pageRoute.AdminStatistics,
      shouldRender: t166,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-statistics-link"
    };
    $[371] = regularIsActiveCheck;
    $[372] = t165;
    $[373] = t166;
    $[374] = t167;
  } else {
    t167 = $[374];
  }
  let t168;
  if ($[375] !== t119 || $[376] !== t137 || $[377] !== t140 || $[378] !== t143 || $[379] !== t146 || $[380] !== t149 || $[381] !== t152 || $[382] !== t164 || $[383] !== t167) {
    t168 = [t119, t137, t140, t143, t146, t149, t152, t164, t167];
    $[375] = t119;
    $[376] = t137;
    $[377] = t140;
    $[378] = t143;
    $[379] = t146;
    $[380] = t149;
    $[381] = t152;
    $[382] = t164;
    $[383] = t167;
    $[384] = t168;
  } else {
    t168 = $[384];
  }
  let t169;
  if ($[385] !== t116 || $[386] !== t168) {
    t169 = {
      id: "admin",
      name: t116,
      dropdownItems: t168,
      mobileIconRenderer: _temp9
    };
    $[385] = t116;
    $[386] = t168;
    $[387] = t169;
  } else {
    t169 = $[387];
  }
  let t170;
  if ($[388] !== t115 || $[389] !== t169 || $[390] !== t18 || $[391] !== t34 || $[392] !== t49 || $[393] !== t61 || $[394] !== t70 || $[395] !== t79 || $[396] !== t97) {
    t170 = [t18, t34, t49, t61, t70, t79, t97, t115, t169];
    $[388] = t115;
    $[389] = t169;
    $[390] = t18;
    $[391] = t34;
    $[392] = t49;
    $[393] = t61;
    $[394] = t70;
    $[395] = t79;
    $[396] = t97;
    $[397] = t170;
  } else {
    t170 = $[397];
  }
  const menuItems = t170;
  let t171;
  if ($[398] !== isReady || $[399] !== menuItems) {
    t171 = {
      menuItems,
      isReady
    };
    $[398] = isReady;
    $[399] = menuItems;
    $[400] = t171;
  } else {
    t171 = $[400];
  }
  return t171;
};
function _temp() {
  return <HomeLineIcon />;
}
function _temp2() {
  return <User03Icon />;
}
function _temp3() {
  return <BrowserIcon />;
}
function _temp4() {
  return <Mail04Icon />;
}
function _temp5() {
  return <MessageDotsSquareIcon />;
}
function _temp6() {
  return <GitPullRequestIcon />;
}
function _temp7() {
  return <FileAttachment01Icon />;
}
function _temp8() {
  return <Sale01Icon />;
}
function _temp9() {
  return <AdminIcon />;
}